import {
  PascodeMetadata,
  PascodeMetadataFetchArgs,
  getPascodeMetadata,
} from '../assets/ts/data/pascode-metadata'
import useServerData from './use-server-data'

function usePascodeMetadata(
  fetchArgs: PascodeMetadataFetchArgs,
  waitOnParentDependency = false
) {
  const {
    data: pascodeMetadata,
    error: pascodeMetadataError,
    fetchData: fetchPascodeMetadata,
    isLoading: pascodeMetadataIsLoading,
  } = useServerData<PascodeMetadata, PascodeMetadataFetchArgs>(
    getPascodeMetadata,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchPascodeMetadata,
    pascodeMetadata,
    pascodeMetadataError,
    pascodeMetadataIsLoading,
  }
}

export default usePascodeMetadata
